import Api from "./api"

const fetchCallParkings = () => {
    return Api().get('/call-parkings')
        .then((response) => {
            return response
        })
}

export {fetchCallParkings}